<template>
	<div class="dropdown dropdown-more">
		<a class="dropdown-toggle btn-more-action" :id="id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
			<i class="fa fa-ellipsis-v"/>
		</a>
		<!-- <button class="dropdown-toggle btn-more-action" :id="id" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
		</button> -->
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		id: {
			type: String,
			required: true,
		},
	}
}
</script>